<template>
  <v-app>
    <v-container class="fill-height pa-0">
      <v-row align="center" justify="center" class="ma-0">
        <v-col cols="3" sm="3" md="3" lg="3">
          <v-card class="pa-8 text-center bra-8">
            <div class="icon-circle mx-auto mb-6">
              <v-icon color="#D4183D" large>mdi-shield-alert-outline</v-icon>
            </div>

            <h1 class="title mb-2">Acesso Negado</h1>
            <p class="subtitle-1 grey--text text--darken-1 mb-6">
              Você não tem permissão para acessar esta página ou recurso.
            </p>

            <v-sheet class="info-box mx-auto mb-6 px-6 py-4">
              <p class="mb-0">
                Se você acredita que isso é um erro, entre em contato com o administrador do
                sistema ou tente fazer login novamente.
              </p>
            </v-sheet>

            <v-btn
              color="#030213"
              height="30"
              class="mb-2 text-none w-100-porcento"
              style="color: #FFFFFF;"
              @click="Helpers.logout()"
            >
              <v-icon left>mdi-logout</v-icon>
              Sair
            </v-btn>

            <div class="back-link">
              <a @click.prevent="voltar" href="#">Voltar à página anterior</a>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import * as Helpers from "@/helpers";

export default {
  name: 'AccessDenied',
  computed: {
    Helpers() {
      return Helpers
    }
  },
  methods: {
    voltar() {
      if (this.$router) this.$router.go(-1)
      else window.history.back()
    },
  }
}
</script>

<style scoped>
.icon-circle {
  width: 72px;
  height: 72px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffe7ea;
}

.info-box {
  max-width: 520px;
  background: #f6f7fb;
  border-radius: 10px;
  color: #717182;
  font-size: 14px;
}

.title {
  font-weight: 700;
}

.back-link a {
  color: #292828;
  text-decoration: none;
  font-size: 14px;
}

.back-link a:hover {
  text-decoration: underline;
}

.fill-height {
  min-height: 100vh;
}
</style>
